<template>
  <section><PublicNavigation /> 
  <div class="wrapper">
  <Register />
  </div>
  </section>
</template>

<script>
import PublicNavigation from '@/components/Navigations/PublicNavigation';
import Register from '@/components/Register/Register';

export default { components: { Register, PublicNavigation } };
</script>

<style lang="scss" scoped>
section {
  .wrapper {
    padding: 20px;
  }
}
</style>
 